/* Main Navigation */



window.addEventListener('click', (ev) => {
  if(document.body.classList.contains('modal-open')) {
    if(!ev.target.classList.contains('.popup-video')) {
      const iframe = ev.target.querySelector('iframe');
      if(iframe) {
        iframe.src = iframe.src;
      }
    }
  }
});

$(document).ready(function () {
  $(window).on("resize", function (e) {
    checkScreenSize();
  });

  checkScreenSize();

  function checkScreenSize(){
    var newWindowWidth = $(window).width();

      $(document).on("scroll",function(){
        if($(document).scrollTop()>100){
          $('.main-nav').addClass('fly');
        } else{
          $('.main-nav').removeClass('fly');
        }
      }); 
  }
});
/* Main Navigation */




/* Main Navigation Hamburger */    
$(document).ready(function() {  


  $(document).on("scroll",function(){
    if($(document).scrollTop()>50){
      $('.hamburger').addClass('float');
    } else{
      $('.hamburger').removeClass('float');
    }
  });      

  $('.body-wrap').off('scroll').on('scroll',function(){ 
    if($('.body-wrap').scrollTop()>100){
      $('.hamburger').addClass('float');
    } else{
      $('.hamburger').removeClass('float');
    }
  });        

  $('.hamburger').on("click",function(){
    $('.main-nav').toggleClass('opened');
  });  

  $('.hamburger').on("click",function(){
    $('body').toggleClass('opened');
  });       


}); 
/* Main Navigation Hamburger */  




/* Review Carousel */      
$(document).ready(function () {



  $('.loop').slick({
    dots: true,
    infinite: false,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  });


  if (document.body.offsetWidth < 960) {
    $('.loop1').slick({
      dots: true,
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

  }
  else {
    $('.loop1.slick-slider').slick('unslick');
  }



  window.addEventListener('resize', () => {
                          if (document.body.offsetWidth < 960) {

    $('.loop1').slick({
      dots: true,
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

  }
  else {
    $('.loop1.slick-slider').slick('unslick');

  }
});



$('.close-i-window').on("click",function(){
  $('body').removeClass('ham-opened');
  $('.i-window').removeClass('opened');
});  




const allAges = document.querySelectorAll('.age-nav > .ageNav');
const allContent = document.querySelectorAll('.age-content > .ager');
let activeAge = document.querySelector('.age-nav > .ageNav.active');
let activeHello = document.querySelector('.age-content > .ager.hello');
let ctaButton = document.querySelector('.cta-button');
const deskAgeSelector = document.querySelectorAll('.ags');


if(allAges.length) {
  allAges.forEach((age, ageInndx) => {
    age.addEventListener('click', () => {
                         if(age === activeAge) {
      return;
    } else {
      activeAge.classList.remove('active');
      activeAge = age;
      activeAge.classList.add('active');
      activeHello.classList.remove('hello');
      activeHello = allContent[ageInndx];
      activeHello.classList.add('hello');
    }
  });
})


deskAgeSelector.forEach((age, ageIndx) => {
  age.addEventListener('click', () => {
                       document.body.classList.add('ham-opened');
  $('.i-window').addClass('opened');                                 
  allAges[ageIndx].click();
  if(document.body.offsetWidth < 960) {
    $('.loop1').slick('slickGoTo', ageIndx); 
  }
});
});

$('a.btn-c').click(function(){
  $('html, body').animate({
    scrollTop: $( $(this).attr('href') ).offset().top
  }, 950);
  return false;
});

ctaButton.addEventListener('click', () => {
                           document.body.classList.add('ham-opened');
$('.i-window').addClass('opened');   
});
}





// podcast page


const paginateItems = document.querySelectorAll('.paginate .items div');

if(paginateItems.length) {
  const pageNumbers = document.querySelector('.pageNumbers');	
  const previousPage = document.querySelector('.previousPage');
  const nextPage = document.querySelector('.nextPage');
  const paginates = [];
  let paginateIndex = 0;

  const pager = (val, active) => {
    document.querySelector('.pageNumbers a.active').classList.remove('active');		
    for(let x = 0; x < paginates[paginateIndex].length; x++) {
      paginates[paginateIndex][x].style.display = "none"
    }
    paginateIndex = val;
    for(let x = 0; x < paginates[paginateIndex].length; x++) {
      paginates[paginateIndex][x].style.display = "block";
      if(paginates[paginateIndex][x].querySelector('iframe').src === "") {
        paginates[paginateIndex][x].querySelector('iframe').src = paginates[paginateIndex][x].dataset.src;
      }
    }
    active.classList.add('active')
  }

  for(let i = 0; i < Math.ceil(paginateItems.length / 5); i++) {
    const a = document.createElement('a');
    a.setAttribute('data-page', i + 1);
    i === 0 ? a.classList.add('active') : false;
    a.setAttribute('href', "javascript:void(0);");
    a.innerText = i + 1;
    pageNumbers.appendChild(a);
    paginates.push([]);

    a.addEventListener('click', () => {
                       if(paginateIndex !== parseInt(a.dataset.page)) {
      pager(parseInt(a.dataset.page) - 1, a); 
    }
  });
}

const pageNumbersAnc = document.querySelectorAll('.pageNumbers a');	

nextPage.addEventListener('click', () => {
                          if(paginateIndex !== paginates.length - 1) {
  pager(paginateIndex + 1, pageNumbersAnc[paginateIndex + 1]);
}
});

previousPage.addEventListener('click', () => {
                              if(paginateIndex !== 0) {
  pager(paginateIndex - 1, pageNumbersAnc[paginateIndex - 1]);
}
});

for(let i = 0; i < paginateItems.length; i++) {
  if(i > 4) {
    paginateItems[i].style.display = "none";
  }
  paginates[(Math.ceil((i + 1) / 5)) - 1].push(paginateItems[i]);
}

}



/* Owl Carousel Jump */    
$('.btnJump').click(function(){
  //             $('#myCarousel').trigger('to.owl.carousel', 3)
});
/* Owl Carousel Jump */   




});
/* Review Carousel */     

